import * as React from "react";

import { generateValidClassNameHandler } from "@/lib/utils";

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> { hasError?: boolean }

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  TextareaProps
>(({
    className,
    hasError,
    ...props
}, ref) => (
    <textarea
        ref={ref}
        className={generateValidClassNameHandler(
            "flex min-h-[80px] w-full rounded bg-gray-50 border border-gray-300 focus:border-primary outline-none px-3 py-2 text-xs md:text-sm placeholder:text-gray-500 disabled:cursor-not-allowed disabled:opacity-50",
            hasError && "border-danger",
            className,
        )}
        {...props}
    />
));
Textarea.displayName = "Textarea";

export { Textarea };
